import React, { Component} from 'react'
import { connect } from 'react-redux'
import { withRouter} from 'react-router-dom'
import {hideLiveViewModal} from '../../utils/liveView/hideLiveViewModal'
import LiveViewContainer from './LiveViewContainer'
import SyncLiveViewContainer from './SyncLiveViewContainer'
import DocumentTitle from 'react-document-title'
import find from 'lodash/find'
import moment from 'moment'
import debounce from 'lodash/debounce'
import {calibratedCurrentTime} from '../../utils/calibratedCurrentTime'
import {updateControl,updateControlSettings,proposeControl} from '../../actions/control'
import {resetControl} from '../../utils/liveView/resetControl'
import {getPollForControl,getSetPollForControl} from '../../utils/liveView/getPollForControl'
import filter from 'lodash/filter'

class LiveViewModalContainer extends Component {

	constructor(props) {
		super(props)	
		this.stopLiveView=this.stopLiveView.bind(this)	
		this.minimiseLiveView=this.minimiseLiveView.bind(this)
		this.isControlELearning=this.isControlELearning.bind(this)
		this.switchNowPlayingMode=this.switchNowPlayingMode.bind(this)
		this.saveDefaultNPModeLocalStorage=this.saveDefaultNPModeLocalStorage.bind(this)
		this.saveSectionCountdownLocalStorage=this.saveSectionCountdownLocalStorage.bind(this)
		this.setCountdownSeconds=this.setCountdownSeconds.bind(this)
		this.cancelCountdown=this.cancelCountdown.bind(this)
		this.incrementCountdown=this.incrementCountdown.bind(this)
		this.saveControlChanges=this.saveControlChanges.bind(this)
		this.handleCountdownEnd=this.handleCountdownEnd.bind(this)
		this.toggleScanning=this.toggleScanning.bind(this)
		this.updateControlCountdownEndsAt=this.updateControlCountdownEndsAt.bind(this)

		this.saveControlChanges=this.saveControlChanges.bind(this)
		this.saveControlChanges = debounce(this.saveControlChanges,150,{'leading': false })

		const sectionNPDefaults = JSON.parse(localStorage.getItem('sectionNPDefaults'))
		
		let nowPlayingMode='liveView'
		if(sectionNPDefaults && props.control &&props.control.section && sectionNPDefaults[props.control.section]){
			nowPlayingMode=sectionNPDefaults[props.control.section]
		}else if(props.currentSection && props.currentSection.studentAccess && props.currentSection.studentAccess.enabled){
			nowPlayingMode='syncLiveView'
		}



		const sectionCountdowns = JSON.parse(localStorage.getItem('sectionCountdowns'))
		let countDownTimerStartSecondsLength=null
		if(sectionCountdowns && props.control &&props.control.section && sectionCountdowns[props.control.section]){
			countDownTimerStartSecondsLength=sectionCountdowns[props.control.section]
		}

		this.state=({
			nowPlayingMode:nowPlayingMode,
			countDownTimerStartSecondsLength:countDownTimerStartSecondsLength,
			classSafeMode:false
		})


	}


	UNSAFE_componentWillReceiveProps(nextProps) {
		if(nextProps.control.section !== this.props.control.section){
			this.setState({classSafeMode:false})
			const sectionNPDefaults = JSON.parse(localStorage.getItem('sectionNPDefaults'))
			let nowPlayingMode='liveView'
			if(sectionNPDefaults && nextProps.control &&nextProps.control.section && sectionNPDefaults[nextProps.control.section]){
				nowPlayingMode=sectionNPDefaults[nextProps.control.section]
			}else if(nextProps.currentSection && nextProps.currentSection.studentAccess && nextProps.currentSection.studentAccess.enabled){
				nowPlayingMode='syncLiveView'
			}
			this.setState({nowPlayingMode:nowPlayingMode})

			const sectionCountdowns = JSON.parse(localStorage.getItem('sectionCountdowns'))
			let countDownTimerStartSecondsLength=null
			if(sectionCountdowns && nextProps.control &&nextProps.control.section && sectionCountdowns[nextProps.control.section]){
				countDownTimerStartSecondsLength=sectionCountdowns[nextProps.control.section]
			}
			this.setState({countDownTimerStartSecondsLength:countDownTimerStartSecondsLength})

		}

		if(nextProps.control.scanning && !this.props.control.scanning){
			if(this.state.nowPlayingMode !=='liveView' && !nextProps.control.countdownEndsAt && this.state.countDownTimerStartSecondsLength){		
				this.updateControlCountdownEndsAt(nextProps.control)
			}
			//analytics 
			if(window.analytics){
 				window.analytics.track('NP start scan',{nowPlayingMode:this.state.nowPlayingMode})
 			}
		}

		
	}

	updateControlCountdownEndsAt(control){
		const nowDate = calibratedCurrentTime()
		let countdownEndsAt=moment(calibratedCurrentTime()).add(this.state.countDownTimerStartSecondsLength, 's')
		
		let newControl=control
		newControl={
			...newControl,
			controlled:nowDate,
			countdownEndsAt:countdownEndsAt
		}
		this.setState({control:newControl})
		this.saveControlChanges()
		this.props.proposeControl(newControl)

	}


	stopLiveView(){
		this.props.resetControl()
		if(this.state.fullScreen){
			this.exitFullscreen()
		}
		this.minimiseLiveView()
	}

	handleCountdownEnd(){
		this.toggleScanning()

	}


	toggleScanning(){
		const nowDate = calibratedCurrentTime()
		let countdownEndsAt=null
		if(this.state.countDownTimerStartSecondsLength && this.state.nowPlayingMode!=='liveView'){
			countdownEndsAt=moment(calibratedCurrentTime()).add(this.state.countDownTimerStartSecondsLength, 's')
		}
		let newControl=this.props.control
		let newScanning=!this.props.control.scanning
		newControl={
			...newControl,
			controlled:nowDate,
			scanning:newScanning,
			revealAnswer:false,
			showGraph:false,
			countdownEndsAt:(newScanning?countdownEndsAt:null)
		}
		if(window.analytics){
			const {onlineStudents,control}=this.props
			const section=this.props.currentSection

			let poll
			if(control && (control.setPoll || control.currentPoll)){		 		
				poll=getPollForControl(control)
			}

 			let type='start'
 			if(this.props.control.scanning){
 				type='stop'
 			}
 			let hasResponses= poll&&poll.hasResponses

 			let onlineStudentsCount=0
 			if(onlineStudents){
 				onlineStudentsCount=Object.keys(onlineStudents).length	
 			}
 			//const onlineStudentsCount=Object.keys(onlineStudents).length
 			let students=[]
 			if(section){
 				students=section.students
 			}
 			const filteredStudents=filter(students,{archived:false})
			const totalStudentCount = filteredStudents.length

			let responseCount=0
			if(poll && poll.responsesByCard){
				responseCount = Object.keys(poll.responsesByCard).length	
			}

			let moreResponsesThanOnlineStudents=false
			if(responseCount>onlineStudentsCount){
				moreResponsesThanOnlineStudents=true
			}
			let reOpeningScan=false
			if(type==='start'&& hasResponses){
				reOpeningScan=true
			}

			let hasCountdown=countdownEndsAt?true:false
			let countdownSeconds=null
			if(this.props.countDownTimerStartSecondsLength){
				countdownSeconds=this.props.countDownTimerStartSecondsLength-1
			}


 			window.analytics.track('Sync NP toggle scan',{
				 	type:type,
				 	hasCountdown:hasCountdown,
				 	countdownSeconds:countdownSeconds,
				 	reOpeningScan:reOpeningScan,
				 	onlineStudentsCount:onlineStudentsCount,
				 	totalStudentCount:totalStudentCount,
				 	responseCount:responseCount,
				 	moreResponsesThanOnlineStudents:moreResponsesThanOnlineStudents

				
			})
 		}


		this.setState({control:newControl})
		this.saveControlChanges()
		this.props.proposeControl(newControl)
	}








	saveControlChanges(){
		this.props.updateControl(this.state.control)
	}



	saveSectionCountdownLocalStorage(seconds){
		const sectionCountdowns = JSON.parse(localStorage.getItem('sectionCountdowns'))
		let newSectionCountdowns
		const sectionId=this.props.currentSection.id
		if(sectionCountdowns){
			newSectionCountdowns=sectionCountdowns
			newSectionCountdowns[sectionId]=seconds
			
		}else{
			newSectionCountdowns={}
			newSectionCountdowns[sectionId]=seconds
		}
		localStorage.setItem('sectionCountdowns', JSON.stringify(newSectionCountdowns))

	}


	setCountdownSeconds(seconds){
		const {control}=this.props	
		let previousCountdownSeconds=null
		if(this.state.countDownTimerStartSecondsLength){
			previousCountdownSeconds=this.state.countDownTimerStartSecondsLength-1
		}
		if(control.scanning){
			let newControl
			const newCountdownEndsAt=moment().add(seconds, 's')
			
			newControl={
				...control,
				controlled:calibratedCurrentTime(),
				countdownEndsAt:newCountdownEndsAt
				}
			this.setState({control:newControl})
			this.saveControlChanges()

		}
		else{
			this.saveSectionCountdownLocalStorage(seconds)
			this.setState({countDownTimerStartSecondsLength:seconds})
		}

		if(window.analytics){
 			window.analytics.track('Set Countdown',{
				 	countdownSeconds:seconds-1,
				 	isScanning:control.scanning,
				 	previousCountdownSeconds:previousCountdownSeconds
				 })
		}		
	}


	cancelCountdown(){
		const control=this.props.control
		const nowDate = calibratedCurrentTime()	
		const newControl={
			...control,
			controlled:nowDate,
			countdownEndsAt:null,
		}

		if(window.analytics){
 			window.analytics.track('Cancel countdown while scannning',{
				 	countdownSeconds:this.state.countDownTimerStartSecondsLength?this.state.countDownTimerStartSecondsLength-1:null
				 })
		}		
		return this.props.updateControlSettings(newControl).then((response)=>{
			return response
		})
	}

	incrementCountdown(incrementSeconds){
		const {control}=this.props
		let oldCountdownEndsAt=null
		let oldCountDownTimerStartSecondsLength=this.state.countDownTimerStartSecondsLength

		if(control.scanning){
			let newControl
			let newCountdownEndsAt
			if(control.countdownEndsAt){
				oldCountdownEndsAt=control.countdownEndsAt
				newCountdownEndsAt=moment(control.countdownEndsAt).add(incrementSeconds, 's')
			}else{
				newCountdownEndsAt=moment().add(incrementSeconds, 's')
			}


			if(moment().isBefore(newCountdownEndsAt)){
				

			newControl={
				...control,
				controlled:calibratedCurrentTime(),
				countdownEndsAt:newCountdownEndsAt
				}
			this.setState({control:newControl})
			this.saveControlChanges()
			this.props.proposeControl(newControl)
		}

		}
		else{
			this.setState({countDownTimerStartSecondsLength:Math.max(this.state.countDownTimerStartSecondsLength+incrementSeconds,11)})
			this.saveSectionCountdownLocalStorage(Math.max(this.state.countDownTimerStartSecondsLength+incrementSeconds,0))
		}
		if(window.analytics){
			let currentCountdownSecondsRemaining=null
			if(oldCountdownEndsAt){
				const countdownTime=Math.max(moment(oldCountdownEndsAt)-moment(),0)
				currentCountdownSecondsRemaining=Math.floor(countdownTime / 1000)
			}
			let countdownTimerStartLengthBeforeIncrement
			if(!control.scanning){
				countdownTimerStartLengthBeforeIncrement=oldCountDownTimerStartSecondsLength-1
			}


 			window.analytics.track('Increment countdown',{
				 	incrementSeconds:incrementSeconds,
				 	isScanning:control.scanning,
				 	scanningCountdownSecondsRemainingBeforeIncrement:currentCountdownSecondsRemaining,
				 	countdownTimerStartLengthBeforeIncrement:countdownTimerStartLengthBeforeIncrement
				 })
		}		
	}







	saveDefaultNPModeLocalStorage(mode){
		const sectionNPDefaults = JSON.parse(localStorage.getItem('sectionNPDefaults'))
		let newSectionNPDefaults
		const sectionId=this.props.currentSection.id
		if(sectionNPDefaults){
			newSectionNPDefaults=sectionNPDefaults
			newSectionNPDefaults[sectionId]=mode
			
		}else{
			newSectionNPDefaults={}
			newSectionNPDefaults[sectionId]=mode
		}
		localStorage.setItem('sectionNPDefaults', JSON.stringify(newSectionNPDefaults))

	}







	switchNowPlayingMode(mode){
		this.saveDefaultNPModeLocalStorage(mode)
		this.setState({nowPlayingMode:mode})
	}

 

	minimiseLiveView(){
		// //#live-view
		if(this.props.history.location.pathname==='/nowplaying/' || this.props.history.location.pathname==='/nowplaying'){
			this.props.history.push('/recent')
		}	
		else hideLiveViewModal()
	}



	isControlELearning(){
		let isELearning=false
		const {currentSection}=this.props
		if(currentSection && currentSection.studentAccess &&  currentSection.studentAccess.enabled ){
			isELearning=true
		}
		return isELearning
	}



	
	render() {
		const {location}=this.props.history
		let visible=false
		if(location.pathname==='/nowplaying' ||location.pathname==='/nowplaying/' || location.hash==='#now-playing'){
			visible=true
		}

		const {nowPlayingMode}=this.state

		//const isELearning=this.isControlELearning()

  		return [ 
  			  <React.Fragment  key='liveView' >	
  			  {(nowPlayingMode==='liveView' || nowPlayingMode==='liveViewHybrid') &&							  
				<LiveViewContainer 
					key='liveViewContainer'
					visible={visible}
					stopLiveView={this.stopLiveView}
					minimiseLiveView={this.minimiseLiveView}
					switchNowPlayingMode={this.switchNowPlayingMode}
					nowPlayingMode={this.state.nowPlayingMode}
					isHybrid={nowPlayingMode==='liveViewHybrid' }
					onlineStudentsCount={this.props.onlineStudentsCount}
					onlineStudents={this.props.onlineStudents}
					setCountdownSeconds={this.setCountdownSeconds}
					countDownTimerStartSecondsLength={this.state.countDownTimerStartSecondsLength}
					incrementCountdown={this.incrementCountdown}
					cancelCountdown={this.cancelCountdown}
					handleCountdownEnd={this.handleCountdownEnd}
					toggleScanning={this.toggleScanning}

				/> 
				}
			  </React.Fragment>
			 ,
			 <React.Fragment  key='syncLiveView' >	
  			  {nowPlayingMode==='syncLiveView' &&							  
				<SyncLiveViewContainer 
					key='liveViewContainer'
					visible={visible}
					stopLiveView={this.stopLiveView}
					minimiseLiveView={this.minimiseLiveView}
					switchNowPlayingMode={this.switchNowPlayingMode}
					nowPlayingMode={this.state.nowPlayingMode}
					onlineStudentsCount={this.props.onlineStudentsCount}
					setCountdownSeconds={this.setCountdownSeconds}
					countDownTimerStartSecondsLength={this.state.countDownTimerStartSecondsLength}
					incrementCountdown={this.incrementCountdown}
					cancelCountdown={this.cancelCountdown}
					handleCountdownEnd={this.handleCountdownEnd}
					toggleScanning={this.toggleScanning}
					classSafeMode={this.state.classSafeMode}
					toggleClassSafeMode={()=>{this.setState({classSafeMode:!this.state.classSafeMode})}}

				/> }
			  </React.Fragment>,

			
		  <React.Fragment key='documentTitle'>
		  {visible &&
		  	<DocumentTitle title='Now Playing – Plickers'/>
		  }
		  </React.Fragment>			
			
		]
	}
}

function mapStateToProps(state) {
	const control=state.control
	let currentSection=null
	let currentSectionAuthorizations=[]
	let currentSectionPresenceMembers={}

	
	if(state.control){
		currentSection=find(state.sections, {'id':state.control.section}) 
 		currentSectionAuthorizations=state.sectionAuthorizations[state.control.section]
 		currentSectionPresenceMembers=state.sectionPresenceMembers[state.control.section]
	}

	let onlineStudents={}
	if(currentSectionPresenceMembers){
			Object.keys(currentSectionPresenceMembers).map((sessionId)=>{
		const authorization=find(currentSectionAuthorizations,{session:sessionId})
		if(authorization){
			onlineStudents[authorization.student]=true
		}
	
	})
	}
	const onlineStudentsCount=Object.keys(onlineStudents).length	
	return {
		control:control,
		currentSection:currentSection,
		onlineStudents:onlineStudents,
		onlineStudentsCount:onlineStudentsCount
	}
}



export default withRouter(connect(
	mapStateToProps,
	{ proposeControl,
		updateControl,
		updateControlSettings,
		resetControl,
		getPollForControl,
		getSetPollForControl}
)(LiveViewModalContainer))